import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmountPipe } from './amount.pipe';

@NgModule({
  imports: [CommonModule],
  providers: [AmountPipe],
  declarations: [AmountPipe],
  exports: [AmountPipe],
})
export class AmountModule {}
